declare const __AGORA_APP_ID__: string
export const AGORA_APP_ID = __AGORA_APP_ID__

export const IS_MEDIA_RECORDER_COMPATIBLE = !!window['MediaRecorder']

export const DEFAULT_VIDEO_WIDTH = 4
export const DEFAULT_VIDEO_HEIGHT = 3
export const DEFAULT_ASPECT_RATIO = DEFAULT_VIDEO_WIDTH / DEFAULT_VIDEO_HEIGHT
